import ReactPaginate from 'react-paginate';

interface IPagination {
	defaultPerPage: number;
	currentPage: number;
	totalItems: number;
	onPageChange: (page: number) => void;
}
export default function Pagination(props: IPagination) {
	const { defaultPerPage = 8 } = props;

	const handlePageClick = (event: { selected: number }) => {
		props.onPageChange(event.selected);
	};

	const pageCount = !!props.totalItems ? Math.ceil(props.totalItems / defaultPerPage) : 1;

	if (pageCount <= 1) return null;
	return (
		<ReactPaginate
			initialPage={props.currentPage}
			forcePage={props.currentPage}
			breakLabel="..."
			nextLabel=""
			onPageChange={(e) => handlePageClick(e)}
			pageCount={pageCount}
			previousLabel=""
			activeClassName=" scale-125 transition-all [&>li]:list-none  [&_a]:bg-primary-500 [&_a]:text-white [&_a]:hover:bg-primary-600 [&_a]:hover:text-white "
			containerClassName="pagination flex-row items-center w-full flex justify-center gap-0 rounded-full [&>li]:list-none [&_a]:rounded-[50%] text-sm"
			disabledClassName="opacity-50 cursor-not-allowed hover:text-white [&>li]:list-none "
			pageLinkClassName="size-8 relative flex items-center justify-center text-primary-600   hover:text-primary-600 hover:text-primary-400 [&>li]:list-none bg-card hover:bg-primary-100"
		/>
	);
}
